import React, { useEffect, useState } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { Col, Row, Input, Label } from "reactstrap";
import { axiosGet } from "../../helper/fetch";

const EventDetails = ({eventaudit}) => {
    const [ details, setDetails ] = useState([]);
    const [ loading, setLoading ] = useState(true);

    const {t} = useTranslation();

    useEffect(() => {
        (async () => {
            await load();
            setLoading(false);
        })()
    }, []);

    const load = async() => {
        try{
            const res = await axiosGet(`api/events/event-details/${eventaudit}`, 'GET');
            setDetails(res.data);
        } catch (err) {
            console.error(err);
        }
    };

    return(
        <div className="details-bg">
            {
                loading ?
                (
                    <div style={{height: '400px'}} className='d-flex justify-content-center align-items-center'>
                        <i data-testid="spinner" className="fa fa-circle-o-notch fa-5x fa-spin" aria-hidden="true"></i>
                    </div>
                )
                : (
                    details.length > 0 ?
                    (details.map( (detail, pos) => (
                        <Row className="row" key={pos}>
                            <Col xs="0" md="1" />
                            <Col xs="1" md="1">
                                <Label style={{ paddingTop: 5, textAlign: 'end'}}>{t("EventDetails.field")}</Label>
                            </Col>
                            <Col xs="2" md="2">
                                <Input value={detail.field} readOnly />
                            </Col>
                            <Col xs="2" md="1">
                                <Label style={{ paddingTop: 5, textAlign: 'end' }}>{t("EventDetails.oldValue")}</Label>
                            </Col>
                            <Col xs="2" md="2">
                                <Input value={detail.oldValue} readOnly />
                            </Col>
                            <Col xs="1" md="1">
                                <Label style={{ paddingTop: 5, textAlign: 'end' }}>{t("EventDetails.newValue")}</Label>
                            </Col>
                            <Col xs="4" md="3">
                                <Input value={detail.newValue} readOnly />
                            </Col>
                            <div style={{height: '1px', width: '80%', backgroundColor: '#999', margin: 'auto', marginTop: '3px', marginBottom: '3px'}}/>
                        </Row>
                    )))
                    : (
                        <h3 style={{textAlign: 'center'}}>{t("EventDetails.noDetails")}</h3>
                    )
                )
            }
            
        </div>
    );
}

export default withTranslation()(EventDetails);